import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-logo">
          <img src="/images/logo.png" alt="Infuse Logo" className="logo-footer" />
          <p>Bringing Natural Beauty to Every Space</p>
        </div>
        <div className="footer-links">
          <div className="footer-link-items">
            <h4>Explore</h4>
            <a href="/">Home</a>
            <a href="/products">Products</a>
            <a href="/contact">Contact</a>
          </div>
          <div className="footer-link-items">
            <h4>Contact Us</h4>
            <p>yash@ncbyinfuse.com</p>
            <p>+971 52 768 2302</p>
            <h4>Address</h4>
            <p> Street 24B 
            Al Quoz Industrial Area 1, Dubai</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;